import gql from 'graphql-tag';

const GET_INTEGRATION_SETUP_META = gql`
  query($input: ID) {
    getIntegrationSetupMeta(integrationRefId: $input)
  }
`;

const GET_INTEGRATION_SETUP_STATE = gql`
  query($input: ID) {
    getIntegrationSetupCurrentState(integrationRefId: $input)
  }
`;

const GET_CALENDAR_LIST = gql`
  query($input: ID!, $entityName: String) {
    getTPEntityItems(integrationRefId: $input, entityName: $entityName)
  }
`;

const GET_SELECTED_CALENDAR = gql`
  query($integrationRefId: ID!, $entityName: String) {
    getMappedTPItemInfo(
      integrationRefId: $integrationRefId
      entityName: $entityName
    )
  }
`;

const SELECT_CALENDAR_TO_INTEGRATE = gql`
  mutation($integrationRefId: ID, $entityName: String, $tpItemId: String) {
    mapIntegrationData(
      integrationRefId: $integrationRefId
      entityName: $entityName
      tpItemId: $tpItemId
    )
  }
`;

const REMOVE_CALENDAR = gql`
  mutation($integrationRefId: ID!) {
    deleteIntegrationV2(integrationRefId: $integrationRefId)
  }
`;

export {
  GET_INTEGRATION_SETUP_META,
  GET_INTEGRATION_SETUP_STATE,
  GET_CALENDAR_LIST,
  SELECT_CALENDAR_TO_INTEGRATE,
  REMOVE_CALENDAR,
  GET_SELECTED_CALENDAR
};
